import { render, staticRenderFns } from "./TagesSaldenBelege.vue?vue&type=template&id=a6937856&scoped=true"
import script from "./TagesSaldenBelege.vue?vue&type=script&lang=ts"
export * from "./TagesSaldenBelege.vue?vue&type=script&lang=ts"
import style0 from "./TagesSaldenBelege.vue?vue&type=style&index=0&id=a6937856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6937856",
  null
  
)

export default component.exports